export default __webpack_public_path__ + "static/media/robot_design.3c10be2e.jpg";